export const isMvno = sub => sub && sub.subscription_type === 'mvno';